<template>
  <div class="footer__lower-social-links flex gap-4">
    <a href="https://www.facebook.com/autoherbertseidl/" target="_blank" rel="noopener noreferrer" :title="t('footer.socials.facebook')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        :aria-label="t('footer.socials.facebook')"
        :aria-hidden="false"
        :alt="t('footer.socials.facebook')"
      >
        <path
          d="M22 12.8716C22 7.31506 17.5229 2.81055 12 2.81055C6.47715 2.81055 2 7.31506 2 12.8716C2 17.8933 5.65684 22.0557 10.4375 22.8105V15.7799H7.89844V12.8716H10.4375V10.6551C10.4375 8.13351 11.9305 6.74067 14.2146 6.74067C15.3088 6.74067 16.4531 6.93718 16.4531 6.93718V9.41316H15.1922C13.95 9.41316 13.5625 10.1888 13.5625 10.9844V12.8716H16.3359L15.8926 15.7799H13.5625V22.8105C18.3432 22.0557 22 17.8935 22 12.8716Z"
          fill="#1A847B"
        />
      </svg>
    </a>
    <a href="https://www.instagram.com/autos.herbertseidl" target="_blank" rel="noopener noreferrer" :title="t('footer.socials.instagram')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        :aria-label="t('footer.socials.instagram')"
        :aria-hidden="false"
        :alt="t('footer.socials.instagram')"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 3.81055H8C5.23858 3.81055 3 6.04913 3 8.81055V16.8105C3 19.5719 5.23858 21.8105 8 21.8105H16C18.7614 21.8105 21 19.5719 21 16.8105V8.81055C21 6.04913 18.7614 3.81055 16 3.81055ZM19.25 16.8105C19.2445 18.6031 17.7926 20.055 16 20.0605H8C6.20735 20.055 4.75549 18.6031 4.75 16.8105V8.81055C4.75549 7.0179 6.20735 5.56604 8 5.56055H16C17.7926 5.56604 19.2445 7.0179 19.25 8.81055V16.8105ZM16.75 9.06055C17.3023 9.06055 17.75 8.61283 17.75 8.06055C17.75 7.50827 17.3023 7.06055 16.75 7.06055C16.1977 7.06055 15.75 7.50827 15.75 8.06055C15.75 8.61283 16.1977 9.06055 16.75 9.06055ZM12 8.31055C9.51472 8.31055 7.5 10.3253 7.5 12.8105C7.5 15.2958 9.51472 17.3105 12 17.3105C14.4853 17.3105 16.5 15.2958 16.5 12.8105C16.5027 11.6162 16.0294 10.4701 15.1849 9.62563C14.3404 8.78114 13.1943 8.30789 12 8.31055ZM9.25 12.8105C9.25 14.3293 10.4812 15.5605 12 15.5605C13.5188 15.5605 14.75 14.3293 14.75 12.8105C14.75 11.2917 13.5188 10.0605 12 10.0605C10.4812 10.0605 9.25 11.2917 9.25 12.8105Z"
          fill="#1A847B"
        />
      </svg>
    </a>
    <a href="https://www.youtube.com/@herbertseidl9330/videos" target="_blank" rel="noopener noreferrer" :title="t('footer.socials.instagram')">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M21.5933 7.20301C21.4794 6.78041 21.2568 6.39501 20.9477 6.08518C20.6386 5.77534 20.2537 5.55187 19.8313 5.43701C18.2653 5.00701 12.0003 5.00001 12.0003 5.00001C12.0003 5.00001 5.73633 4.99301 4.16933 5.40401C3.74725 5.52415 3.36315 5.75078 3.0539 6.06214C2.74464 6.3735 2.52062 6.75913 2.40333 7.18201C1.99033 8.74801 1.98633 11.996 1.98633 11.996C1.98633 11.996 1.98233 15.26 2.39233 16.81C2.62233 17.667 3.29733 18.344 4.15533 18.575C5.73733 19.005 11.9853 19.012 11.9853 19.012C11.9853 19.012 18.2503 19.019 19.8163 18.609C20.2388 18.4943 20.6241 18.2714 20.934 17.9622C21.2439 17.653 21.4677 17.2682 21.5833 16.846C21.9973 15.281 22.0003 12.034 22.0003 12.034C22.0003 12.034 22.0203 8.76901 21.5933 7.20301ZM9.99633 15.005L10.0013 9.00501L15.2083 12.01L9.99633 15.005Z"
          fill="#1A847B"
        />
      </svg>
    </a>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n();
</script>

<style></style>
